export enum DeliveryMethodCategoryEnum {
  DEFAULT = 'default',
  FRESH = 'fresh',
  ULTRA_FRESH = 'ultra_fresh',
}
